/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 1 hook(s) need dependency review; fix each and remove this directive */
import { useEffect, useState } from "react";
import axiosWrapper from "../../services/axiosWrapper";
import { getBackendUrl } from "../../utils";
import { untranslated, useTranslation } from "@i18n";
import type { GetAllUsersInSpaceResponse, IncludedUsersOfProjectResponse } from "@ServerTypes/accounts/accounts.schema";
import type { UpdateModuleResourcePermissionResponse } from "@ServerTypes/permissions/permissions.schema";
import _ from "lodash";
import TextFieldComponent from "../../cubeComponent/Mui_Form/TextFieldComponent";
import UserNameTagComponent from "../../cubeComponent/html/UserNameTagComponent";
import SelectDropDown from "@CubeComponents/Mui_Form/SelectDropDown";
import { BUTTON_TYPES } from "../../cubeComponent/constants/globalVariable";
import IconComponent from "../../cubeComponent/icons";
import { getRoleIdNameMapper, setModulePermissions } from "./constants";
import { folderRoles } from "@Helpers/constants";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_ERROR, TOAST_TYPE_SUCCESS } from "@Services/constants";
import { useDispatch } from "react-redux";
import Text from "@CubeComponents/html/Text/Text";

type users = {
  id: string;
  role: string;
  permissions: Array<number>;
};

type SpaceUsersAccessProps = {
  spaceId?: string;
  users: users[];
  projectId?: string;
  resourceId: string;
  module:
    | "CLASH"
    | "FORMS"
    | "TASKS"
    | "ISSUES"
    | "REVIEWS"
    | "MAILBOX"
    | "ASSETS"
    | "CONTRACTS"
    | "ESTIMATES"
    | "SCHEDULES";
  accessChangeCompleteCallback?: () => void;
};
const ModuleUsersAccess = ({
  spaceId,
  users = [],
  module,
  resourceId,
  projectId,
  accessChangeCompleteCallback,
}: SpaceUsersAccessProps) => {
  const { t } = useTranslation();
  const [allUsers, setAllUsers] = useState([]);
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [permissionsArray, setPermissionsArray] = useState([]);
  const dispatch = useDispatch();

  const folderRolesData: any = folderRoles();

  const mapUserWithPermission = (usersList: Array<any>) => {
    const finalUsers: any = usersList.map((user: any) => {
      const value: any = {};
      const roleIdNameMapper = getRoleIdNameMapper(module);
      const userRole = users.find((u: any) => u.id == user.id);
      if (userRole) {
        value.frontendName = roleIdNameMapper[userRole.role];
        value.id = userRole.role;
      } else {
        value.frontendName = roleIdNameMapper[7];
        value.id = 7;
      }
      return {
        ...user,
        value,
      };
    });
    setAllUsers(finalUsers);
    setFilteredUsers(finalUsers);
  };

  const fetchAllSpaceUsers = async () => {
    const response = await axiosWrapper.post<GetAllUsersInSpaceResponse>(
      `${getBackendUrl()}/accounts/getAllUsersInSpace`,
      {
        spaceId,
      },
    );
    if (response.data.status) {
      mapUserWithPermission(response.data.result as any[]);
    }
  };

  const fetchAllProjectUsers = async () => {
    const query = { value: { projectId, source: "projectSetting" } };
    const response = await axiosWrapper.post<IncludedUsersOfProjectResponse>(
      `${getBackendUrl()}/accounts/includedUsersController`,
      query,
    );
    if (response.data.status) {
      mapUserWithPermission((response.data.result ?? []) as any[]);
    }
  };

  useEffect(() => {
    if (spaceId) {
      fetchAllSpaceUsers();
    } else if (projectId) {
      fetchAllProjectUsers();
    }
  }, [spaceId, projectId]);

  useEffect(() => {
    const res = setModulePermissions(module);
    setPermissionsArray(res);
  }, [module]);

  const handleSearchUsers = (args: any) => {
    const value = args.target.value?.toLowerCase() || "";
    setFilteredUsers(() => allUsers.filter((user: any) => user.fullName?.toLowerCase().includes(value)));
  };

  const additionalvalidations = ({ option, userId }: any) => {
    if (module == "FORMS") {
      if (option.id == folderRolesData.RESOURCE_ADMIN.id || option.id == folderRolesData.RESOURCE_EDITOR.id) {
        dispatch(
          showToastNotification({
            content: t("This permission can only be updated through the corresponding form flow."),
            type: TOAST_TYPE_ERROR,
          }),
        );
        return false;
      }
      const isUserHaveFullAccess = users.find((user: any) => user.id == userId && [1, 2].includes(user.role));
      if (isUserHaveFullAccess) {
        dispatch(
          showToastNotification({
            content: t("Permission for this user cannot be changed"),
            type: TOAST_TYPE_ERROR,
          }),
        );
        return false;
      }
    } else if (module === "REVIEWS") {
      const currentRole: any = users.find((user: any) => user.id == userId)?.role;
      if (option.id == folderRolesData.RESOURCE_ADMIN.id && currentRole !== folderRolesData.RESOURCE_EDITOR.id) {
        dispatch(
          showToastNotification({
            content: t("Only can update permission users can be promoted to Full Access."),
            type: TOAST_TYPE_ERROR,
          }),
        );
        return false;
      }
    }
    return true;
  };
  const setUserPermissionData = async ({ option, userId }: any) => {
    const res = additionalvalidations({ option, userId });
    if (!res) {
      return;
    }
    const payload: any = {
      role: option.id,
      userId,
      resourceId,
      module,
    };
    const response = await axiosWrapper.post<UpdateModuleResourcePermissionResponse>(
      `${getBackendUrl()}/permissions/updateModuleResourcePermission`,
      payload,
    );
    if (response.data.status) {
      dispatch(
        showToastNotification({
          content: t("Successfully updated the permission"),
          type: TOAST_TYPE_SUCCESS,
        }),
      );
      setAllUsers((prev: any) => {
        const newData = prev.map((user: any) => {
          if (user.id == userId) {
            user.value = {
              frontendName: option.frontendName,
              id: option.id,
            };
          }
          return user;
        });
        return newData;
      });
      accessChangeCompleteCallback?.();
    } else {
      dispatch(
        showToastNotification({
          content: untranslated(response.data.errorMessage),
          type: TOAST_TYPE_ERROR,
        }),
      );
    }
  };

  const itemTemplate = (data: any) => {
    return (
      <div className="flex gap-3 p-1 items-center">
        <div>
          <IconComponent name={data.name} width="1.5rem" height="1.5rem" />
        </div>
        <div className="flex flex-col">
          <div className="font-semibold">{data.frontendName}</div>
          <Text className="text-xs" id="qweqwe" sx={{ whiteSpace: "normal" }}>
            {data.description}
          </Text>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col gap-5">
      <div>
        <TextFieldComponent onChange={handleSearchUsers} placeholder="Search User(s)" />
      </div>
      <div className="flex flex-col gap-5">
        {filteredUsers.map((user: any) => (
          <div key={user.id} className="flex">
            <div className="flex-1">{<UserNameTagComponent id={user.id} />} </div>
            <div className="flex-1 flex justify-end">
              <SelectDropDown
                id={`userRole_${user.id}`}
                renderOption={itemTemplate}
                onChange={(option) => setUserPermissionData({ option, userId: user.id })}
                value={user.value}
                buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
                fields={{
                  text: "frontendName",
                  value: "id",
                }}
                options={permissionsArray}
                buttonWidth="9.375rem"
                popupAlign="right"
                popperWidth={400}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
export default ModuleUsersAccess;
